module.exports = __webpack_public_path__ + "c43542f4ad8a59af2ed811af42933878.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/KH.svg
// module id = 853R
// module chunks = 0